<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-04-10 14:21:11
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-04-14 10:57:40
 * @FilePath: \crm-product\src\views\dms\views\sharing_agreement\terminal_report\form\detail.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="home">
    <Page
      :paramsProps="{
        year: formConfig.row.year,
        userCode: formConfig.row.userCode,
        orgCode: formConfig.row.orgCode,
      }"
    />
    <div slot="footer" class="dialog-footer">
      <el-button
        type="danger"
        @click="closeModal"
        size="small"
        icon="el-icon-close"
        >关闭</el-button
      >
    </div>
  </div>
</template>

<script>
import Page from './detail';

export default {
  name: 'detail',
  props: {
    formConfig: Object,
  },
  components: {
    Page,
  },
  methods: {
    // 关闭弹窗
    closeModal() {
      this.$emit('onClose');
    },
  },
};
</script>

<style lang='less' scoped>
.home {
  height: calc(100vh - 166px);
}
</style>
